import { EnumGroup } from "./EnumGroup";

const enumGroupMap: Record<EnumGroup, string> = {
  [EnumGroup.Zero]: "0",
  [EnumGroup.One]: "1",
  [EnumGroup.Two]: "2",
  [EnumGroup.TwoTR]: "2TR",
  [EnumGroup.Three]: "3",
  [EnumGroup.Four]: "4",
  [EnumGroup.FourTR]: "4TR",
  [EnumGroup.Five]: "5",
  [EnumGroup.Six]: "6",
  [EnumGroup.Seven]: "7",
  [EnumGroup.Eight]: "8",
  [EnumGroup.Nine]: "9",
  [EnumGroup.Ten]: "10",
  [EnumGroup.Eleven]: "11",
  [EnumGroup.Twelve]: "12",
  [EnumGroup.Thirteen]: "13",
  [EnumGroup.Fourteen]: "14",
  [EnumGroup.Fifteen]: "15",
  [EnumGroup.Sixteen]: "16",
  [EnumGroup.Seventeen]: "17",
  [EnumGroup.Eighteen]: "18",
  [EnumGroup.PEN]: "PEN",
  [EnumGroup.PEND]: "PEND",
};

export const convertNumber = (enumGroup: number): string => {
  const group = EnumGroup[EnumGroup[enumGroup] as keyof typeof EnumGroup];
  return convertEnum(group);
};

export const convertEnum = (enumGroup: EnumGroup): string => {
  return enumGroupMap[enumGroup];
};

export const convertBackToNumber = (groupString: string): number => {
  const [key, enumGroup] = Object.entries(enumGroupMap).find(
    ([key, value]) => value === groupString
  ) || [undefined, undefined];
  return key ? Number(key) : 0;
};
